import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MethodsEffects } from './state/methods/methods.effects';
import { MethodsFacade } from './state/methods/methods.facade';
import { paymentMethodsFeatureKey, paymentMethodsReducer } from './state/methods/methods.reducer';
import { ProfilesEffects } from './state/profiles/profiles.effects';
import { ProfilesFacade } from './state/profiles/profiles.facade';
import { paymentProfilesFeatureKey, paymentProfilesReducer } from './state/profiles/profiles.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(paymentMethodsFeatureKey, paymentMethodsReducer),
        StoreModule.forFeature(paymentProfilesFeatureKey, paymentProfilesReducer),
        EffectsModule.forFeature([MethodsEffects, ProfilesEffects])
    ],
    providers: [MethodsFacade, ProfilesFacade]
})
export class PaymentDomainModule {}
